// Every entity kind that can appear in search results, recents, and badges.
export enum ItemType {
  Company = 'company',
  Contact = 'contact',
  CustomField = 'custom-field',
  Fund = 'fund',
  FundGroup = 'fund-group',
  Investor = 'investor',
  MailingList = 'mailing-list',
  Forecast = 'forecast',
  Security = 'security',
  Report = 'report',
}
